import { StrictMode } from 'react';
import * as ReactDOMClient from 'react-dom/client';
import { RouterProvider } from 'react-router';

import { environment } from '@anyx/app-core/env';

import { initI18n } from '@anyx/shared-i18n';
import {
  Environment,
  LanguageUtils,
  pwaStore,
  environmentStore,
  DocUtils,
  TimezoneUtils,
  applyGoogleTranslateFix,
} from '@anyx/shared-utils';

import { getRouter } from './app/app.routing';
import { initWebVitals } from './monitoring';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

applyGoogleTranslateFix();

const version = process.env['NX_PUBLIC_VERSION'] || '';
// eslint-disable-next-line no-console
console.log(
  `${environment.appName} Version : ${version} ; Configuration : ${Environment[environment.env]}`
);
const SUPPORTED_LANGUAGES = ['en-US', 'ja-JP', 'zh-CN', 'ko-KR'];
const DEFAULT_LANGUAGE = 'en-US';

environmentStore.setState((state) => ({
  ...state,
  environment: environment.env,
  currentTimezone: TimezoneUtils.getLocalTimezone(),
  currentLanguage: LanguageUtils.fromI18nLanguage(DEFAULT_LANGUAGE),
  languages: SUPPORTED_LANGUAGES.map(LanguageUtils.fromI18nLanguage),
}));

DocUtils.DOCUMENT_URL = environment.help.gitbook;

initWebVitals();
initI18n({
  fallbackLng: DEFAULT_LANGUAGE,
  interpolation: {
    escapeValue: false,
  },
  load: 'currentOnly',
  debug: environment.enableDebug,
  lng: DEFAULT_LANGUAGE,
  supportedLngs: SUPPORTED_LANGUAGES,
  ns: ['shared', 'gql'],
});

const root = ReactDOMClient.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <StrictMode>
    <RouterProvider router={getRouter()} />
  </StrictMode>
);

if ([Environment.STAGING, Environment.PRODUCTION].includes(environment.env)) {
  serviceWorkerRegistration.register({
    path: 'service-worker.js',
    onSuccess: () => pwaStore.setState((state) => ({ ...state, isReady: true })),
    onUpdate: () => pwaStore.setState((state) => ({ ...state, hasUpdate: true })),
  });
}
